import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';
import GoogleMapReact from 'google-map-react';

import PoiMarker from '../PoiMarker';
import PlaceCard from '../PlaceCard';
import {TPlace} from '../../Definitions';

const getMapOptions = () => ({
    disableDefaultUI: true,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: true,
    scaleControl: true,
});

type TMapProps = {
    config: {
        coordinates: {
            lat: number;
            lng: number;
        },
        zoom: number;
    };
    places: TPlace[];
    activePlace: TPlace|null;
    setActivePlace: (place: TPlace|null) => void;
    externalActivatedPlace?: TPlace;
    onChangeBounds: (bounds: google.maps.LatLngBounds) => void;
    isUpdating?: boolean;
    mapStyles: google.maps.MapTypeStyle[];
    className?: string;
};
export default ({config, places, activePlace, setActivePlace, onChangeBounds, isUpdating, mapStyles, className}: TMapProps) => {
    const mapRef = React.useRef<google.maps.Map|null>(null);
    const mapContainer = React.useRef<HTMLDivElement|null>(null);

    React.useEffect(() => {
        if (activePlace && mapContainer.current && mapRef.current && activePlace.geometry?.location) {
            mapRef.current.panTo(activePlace.geometry?.location);
        }
    }, [activePlace]);

    const onPlaceClick = (place_id: string) => setActivePlace(
        place_id === activePlace?.place_id
            ? null
            : places.find(place => place.place_id === place_id) || null);

    return (
        <div
            ref={mapContainer}
            className={classNames(styles.mapContainer, className)}
        >
            <GoogleMapReact
                defaultCenter={config.coordinates}
                defaultZoom={config.zoom}
                options={{
                    ...getMapOptions(),
                    styles: mapStyles as GoogleMapReact.MapTypeStyle[],
                }}
                onChange={({bounds: {sw, ne}}) => {
                    const updatedBounds = new google.maps.LatLngBounds(sw, ne);

                    if (activePlace?.geometry?.location
                        && !updatedBounds.contains(activePlace.geometry.location)
                    ) {
                        setActivePlace(null);
                    }

                    onChangeBounds(updatedBounds);

                }}
                onChildClick={onPlaceClick}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({map}) => mapRef.current = map}
            >
                {
                    (activePlace && activePlace.geometry) &&
                        <PoiMarker
                            key={activePlace.place_id}
                            isActive={true}
                            lat={activePlace.geometry?.location.lat()}
                            lng={activePlace.geometry?.location.lng()}
                            {...activePlace}
                        />
                }
                {
                    places.map(place => (
                        place.geometry && place.place_id !== activePlace?.place_id
                            ? (
                                <PoiMarker
                                    key={place.place_id}
                                    isActive={place.place_id === activePlace?.place_id}
                                    lat={place.geometry?.location.lat()}
                                    lng={place.geometry?.location.lng()}
                                    {...place}
                                />
                            )
                            : null
                    ))
                }
            </GoogleMapReact>
            {
                isUpdating ?
                    (
                        <div className={styles.spinner}>
                            Karte wird aktualisiert ...
                        </div>
                    )
                    : null
            }
            {
                activePlace &&
                    <PlaceCard
                        place={activePlace}
                        isActive
                        className={styles.card}
                    />
            }
        </div>
    );
}
